import React from 'react';
import HeadMenu from './HeadMenu';
import {Layout, Image, Affix, BackTop} from 'antd';
import {Outlet} from 'react-router-dom';
const {Header, Footer, Content} = Layout;

/**
 * Display for HeadMenu components.
 * @return {HeadMenu}
 */
const HeadMenuComp = () => {
  return (
    <Layout>
      <Affix>
        <Header className='header'>
          <div className="logo">
            <Image src='https://static.igem.wiki/teams/4464/wiki/home/imoage1.png' className='imLogo' preview={false}/>
          </div>
          <HeadMenu/>
        </Header>
      </Affix>
      <BackTop/>
      <Layout style={{padding: '1% 6% 4% 4%', background: 'url(https://static.igem.wiki/teams/4464/wiki/home/videohome-1.gif)', backgroundAttachment: 'fixed', backgroundSize: '60vh'}}>
        <Outlet/>
      </Layout>
      <Footer style={{background: 'url(https://static.igem.wiki/teams/4464/wiki/home/videohome-1.gif)'}}>
        <Layout style={{background: 'transparent', borderWidth: '2.5vh', border: 'solid', borderColor: 'white'}}>
          <Content style={{marginLeft: '50%', transform: 'translateX(-50%)', width: '170vh', background: 'transparent'}}>
            <Image style={{position: 'inline'}} src='https://static.igem.wiki/teams/4464/wiki/home/tec1.png' preview={false}/>
            <p style={{textAlign: 'center', color: 'white', margin: '10vh'}}>© 2022 - Content on this site is licensed under a Creative Commons Attribution 4.0 International license.</p>
            <p style={{textAlign: 'center', color: 'white', margin: '10vh'}}>This website was designed with React Native and Ant Design . React Native is an open-source UI software framework Ant Design is an enterprise-class UI design language and React UI library For further information, please consult the official website of React Native as well as that of Ant Design.</p>
            <p style={{textAlign: 'center', color: 'white', margin: '10vh'}}>The repository used to create this website is available at <a href='https://gitlab.igem.org/2022/tecccm'>https://gitlab.igem.org/2022/tecccm</a></p>
            <Image width='40vh' style={{marginLeft: '160%', marginBottom: '5vh'}} src= 'https://static.igem.wiki/teams/4464/wiki/home/redes.png'/>
          </Content>
        </Layout>
      </Footer>
    </Layout>
  );
};
export default HeadMenuComp;
